import { lazy } from "react";

const RELOAD_KEY = "chunk_reload_at";

// Componente caricato solo quando serve; se il file non esiste più (nuova versione pubblicata) ricarica la pagina una volta
export const lazyNamed = (loader, name = "default") => {
  const load = () =>
    loader()
      .then((m) => ({ default: m[name] }))
      .catch((e) => {
        const last = Number(sessionStorage.getItem(RELOAD_KEY) || 0);
        if (Date.now() - last > 60000) {
          sessionStorage.setItem(RELOAD_KEY, String(Date.now()));
          window.location.reload();
          return new Promise(() => {});
        }
        throw e;
      });
  const Comp = lazy(load);
  Comp.preload = () => loader().catch(() => {});
  return Comp;
};

// Scarica in background le schermate non ancora aperte, così il cambio scheda resta immediato
export const preloadLater = (comps, delay = 2500) => {
  const t = setTimeout(() => comps.forEach((c) => c.preload()), delay);
  return () => clearTimeout(t);
};
